module.exports = "https://static.wmbcdn.com/uniweb/images/b6d324b2d994e4581338ac266ac52c0a.svg";